import { apiFetch, isErrorResult } from "../../../../app/apiClient.js";
import { toast } from "../../../layout/app-toast/utils/toastManager.js";
import { validateData, getContent } from "./tableManager.js";

async function collectData() {
    const content = getContent();
    if (!content) return null;
    const name = content.querySelector("#inputCustomerName")?.getValue?.() ?? "";
    return {
        name,
        shortName:          content.querySelector("#inputCustomerShortName")?.getValue?.()         || name || null,
        language:           content.querySelector("#inputCustomerLanguage")?.getValue?.()           ?? "1",
        dashboardModuleIds:    content.querySelector("#inputCustomerDashboardModules")?.getValue?.()       ?? [],
        permittedLanguageIds:  content.querySelector("#inputCustomerPermittedLanguages")?.getValue?.()    ?? [],
    };
}

export async function createCustomer(applications = [], services = []) {
    const data = await collectData();
    if (!data) return;

    const missingFields = await validateData(data);
    if (missingFields.length > 0) return true;

    const result = await apiFetch("Customers", "POST", {
        Name:                data.name,
        ShortName:           data.shortName,
        Language:            parseInt(data.language),
        DashboardModuleIds:  data.dashboardModuleIds,
        PermittedLanguageIds: data.permittedLanguageIds.map(Number),
        Applications:        applications,
        Services:            services,
    });
    if (isErrorResult(result)) return result ? true : undefined;

    const { customerList, detailedCustomer } = result;
    document.dispatchEvent(new CustomEvent('customer-data-changed', {
        detail: { action: 'created', customer: customerList, detailedCustomer, skipReload: true },
        bubbles: true, composed: true,
    }));
    toast("Kunde erfolgreich hinzugefügt!", "success");
    return customerList;
}

export async function editCustomer(customerId) {
    const data = await collectData();
    if (!data) return;

    const missingFields = await validateData(data);
    if (missingFields.length > 0) return true;

    const updatedCustomer = await apiFetch(`Customers/${customerId}`, "PATCH", {
        Name:     data.name,
        ShortName: data.shortName,
        Language: parseInt(data.language),
    });
    if (isErrorResult(updatedCustomer)) return updatedCustomer ? true : undefined;

    document.dispatchEvent(new CustomEvent('customer-data-changed', {
        detail: { action: 'updated', customer: updatedCustomer },
        bubbles: true, composed: true,
    }));
    toast("Kunde erfolgreich aktualisiert!", "success");
    return updatedCustomer;
}

export async function editCustomerApplications(customerId, applications) {
    const result = await apiFetch(`CustomerApplication/${customerId}`, 'PATCH', applications);
    if (isErrorResult(result)) return true;

    toast("Applikationen aktualisiert!", "success");
    return result;
}

export async function editCustomerServices(customerId, services) {
    const result = await apiFetch(`Customers/${customerId}/Services`, 'PATCH', services);
    if (isErrorResult(result)) return true;

    toast("Services aktualisiert!", "success");
    return result;
}

export async function editCustomerDashboardModules(customerId, moduleIds) {
    const result = await apiFetch(`Customers/${customerId}/DashboardModules`, 'PATCH', { ModuleIds: moduleIds });
    if (isErrorResult(result)) return true;

    toast("Dashboard Module aktualisiert!", "success");
    return result;
}

export async function editCustomerPermittedLanguages(customerId, languageIds) {
    const result = await apiFetch(`Customers/${customerId}/PermittedLanguages`, 'PATCH', { LanguageIds: languageIds });
    if (isErrorResult(result)) return true;

    toast("Erlaubte Sprachen aktualisiert!", "success");
    return result;
}

export async function deleteCustomer(customerId) {
    const result = await apiFetch(`Customers/${customerId}`, "DELETE");
    if (result !== 404 && isErrorResult(result)) return;

    const softDeleted = result && typeof result === 'object' && result.id;
    document.dispatchEvent(new CustomEvent('customer-data-changed', {
        detail: { action: 'deleted', id: customerId, customer: softDeleted ? result : null, skipReload: !!softDeleted },
        bubbles: true, composed: true,
    }));
    if (result !== 404) toast(softDeleted ? "Kunde erfolgreich deaktiviert!" : "Kunde erfolgreich gelöscht!", "success");
}

export async function enableCustomer(customerId) {
    const result = await apiFetch(`Customers/${customerId}/Status`, "PATCH");
    if (isErrorResult(result)) return;

    document.dispatchEvent(new CustomEvent('customer-data-changed', {
        detail: { action: 'enabled', id: customerId, skipReload: true },
        bubbles: true, composed: true,
    }));
    toast("Kunde erfolgreich reaktiviert!", "success");
}
